<div class="row error-page-bg">
  <div class="col-md-12 text-center v-middle">
    <img src="assets/Venio_Logo_White_Transparent_BG.png" class="img-responsive m-b-20" height="50" alt="">
    <p class="display-1 m-b-0">{{ 't.404' | translate }}</p>
    <p class="display-4 m-b-40">{{ 'm.error.not.found' | translate }}</p>
    <button class="btn btn-outline-light m-r-10" (click)="back()" >{{ 'l.back' | translate }}</button>
    <button class="btn btn-outline-light" [routerLink]="['/']">{{ 'l.go.home' | translate }}</button>
  </div>
</div>